export const paginatedCarriersSelector = state => state.pagination.carriers;
